<template>
    <div>
        <Layout>
            <div v-if="!isLoading" class="col-lg-12">
                <div class="position-absolute d-flex align-items-center justify-content-end" style="top: -46px; right: 1rem; z-index: 10">
                    <p class="mb-0 mr-2" style="font-size: 12px; color: #74788d">
                        {{ `${$t('managerForm.textDateTimeSync')}${formData.last_publish_updated}` }}
                    </p>
                    <button
                        class="btn btn-outline-warning btn-only-icon mr-2"
                        style="padding-block: 7px"
                        :disabled="formData.status == 1 || formData.block_arrangement === null"
                        @click="onHandleTranformPage"
                    >
                        <i class="mdi mdi-web"></i>
                    </button>
                    <button class="btn btn-common btn-warning" @click="onHandleSyncLandingPage">
                        {{ $t('managerForm.syncFormPublic') }}
                    </button>
                </div>
                <div class="card mb-0">
                    <div class="card-body" style="min-height: 100vh">
                        <b-tabs
                            v-model="modelTab"
                            vertical
                            justified
                            nav-class="nav-tabs-custom tabs_landing--page disabled"
                            content-class="p-3 text-muted"
                        >
                            <b-tab v-for="(tab, index) in TABS" :key="index" class="border-0" :disabled="tab.disabled">
                                <template v-slot:title>
                                    <span class="">{{ tab.name }}</span>
                                </template>
                                <div>
                                    <template v-if="isUploadLP">
                                        <SettingBasicLP
                                            v-if="tab.id == 1"
                                            :dataForm.sync="formData"
                                            :configForm="configFormBasicLP"
                                            :listCommon="dataListCommonUse"
                                            :isUpload="true"
                                        />
                                        <UploadZipLP
                                            v-else-if="tab.id == 2"
                                            :dataForm.sync="formData"
                                            :stage="1"
                                            period="start"
                                            title="LP開始年月日〜キャンペーン開始年月日の期間に表示するページ"
                                            htmlFileName="index.html"
                                        />
                                        <UploadZipLP
                                            v-else-if="tab.id == 3"
                                            :dataForm.sync="formData"
                                            :stage="2"
                                            period="going"
                                            title="キャンペーン開始年月日〜キャンペーン終了年月日の期間に表示するページ"
                                            htmlFileName="index.html"
                                        />
                                        <UploadZipLP
                                            v-else-if="tab.id == 4"
                                            :dataForm.sync="formData"
                                            :stage="3"
                                            period="end"
                                            title="キャンペーン終了年月日〜LP終了年月日の期間に表示するページ"
                                            htmlFileName="index.html"
                                        />
                                    </template>
                                    <template v-else>
                                        <SettingBasicLP
                                            v-if="tab.id == 1"
                                            :dataForm.sync="formData"
                                            :configForm="configFormBasicLP"
                                            :listCommon="dataListCommonUse"
                                        />
                                        <SettingDesign v-else-if="tab.id == 2" :dataForm.sync="formData.style_setting" />
                                        <SettingBlocks v-else-if="tab.id == 3" :dataForm.sync="formData" />
                                        <SettingFirstView v-else-if="tab.id == 4" :dataForm.sync="formData.first_view" />
                                        <SettingTimeApplication
                                            v-else-if="tab.id == 5"
                                            :dataForm.sync="formData.application_period"
                                            :configForm="configFormTimeApplication"
                                        />
                                        <SettingPrize
                                            v-else-if="tab.id == 6"
                                            :dataForm.sync="formData.prize_settings"
                                            :configForm="configFormPrizeSettings"
                                        />
                                        <SettingTargetProduct
                                            v-else-if="tab.id == 7"
                                            :dataForm.sync="formData.block_target_product"
                                            :configForm="configFormTargetProduct"
                                        />
                                        <SettingApplicationMethod
                                            v-else-if="tab.id == 8"
                                            :dataForm.sync="formData.block_application_method"
                                            :configForm="configFormApplicationMethods"
                                        />
                                        <SettingReceiptPhotography v-else-if="tab.id == 9" :dataForm="formData" />
                                        <SettingApplicationRule
                                            v-else-if="tab.id == 10"
                                            :dataForm.sync="formData.block_application_rule"
                                            :configForm="configFormApplicationRule"
                                        />
                                        <SettingContact
                                            v-else-if="tab.id == 11"
                                            :dataForm.sync="formData.block_contact"
                                            :configForm="configFormContact"
                                        />
                                        <SettingShare v-else-if="tab.id == 12" :dataForm.sync="formData.block_share" :configForm="configFormShare" />
                                    </template>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                    <ModalListPreview
                        :formData="{
                            ...formData,
                            forms: formData.campaign_forms,
                            landing_pages: formData.campaign_lps
                        }"
                        :config.sync="configModalListPrv"
                    />
                </div>
                <Footer>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr">
                        <div class="d-flex align-items-center" style="gap: 0.7rem">
                            <button @click="handleCancel" class="btn btn-common-footer"><i class="ri-list-check"></i>{{ $t('btn.backList') }}</button>
                            <button @click="handleGetDetail" class="btn btn-common btn-info" style="min-width: 76px">
                                <i class="ri-arrow-left-line"></i>{{ $t('btn.goToDetail') }}
                            </button>
                        </div>
                        <div class="text-center" style="margin-left: 50px">
                            <div class="d-flex align-items-center justify-content-start" style="gap: 1rem">
                                <button type="button" class="btn btn-common-footer" @click="() => (configModalListPrv.model = true)">
                                    <i class="ri-link-m"></i>{{ $t('pageCampaign.listLinkLPAndForm') }}
                                </button>
                                <button class="btn btn-common-footer" @click="onHandleRefreshCPOnLP">
                                    <i class="ri-equalizer-line"></i>{{ $t('landingPage.reflectedCPOnLP') }}
                                </button>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end" style="gap: 1rem">
                            <button :class="`btn btn-common-footer`" @click="togglePreview">
                                <i class="ri-eye-line"></i>{{ $t('btn.preview') }}
                            </button>
                            <button type="submit" @click="handleSubmit" class="btn btn-common btn-success" style="min-width: 100px">
                                {{ $t('btn.save') }}
                            </button>
                        </div>
                    </div>
                </Footer>
            </div>
            <div class="d-flex justify-content-center" v-else>
                <LoadingIcon />
            </div>
        </Layout>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Footer from '@/components/Footer/main.vue';
import SettingBasicLP from '../components/setting-basic/main.vue';
import SettingFirstView from '../components/setting-first_view/main.vue';
import SettingPrize from '../components/setting-prize/main.vue';
import SettingTargetProduct from '../components/setting-target_product/main.vue';
import SettingDesign from '../components/setting-design/main.vue';
import SettingBlocks from '../components/setting-blocks/main.vue';
import SettingTimeApplication from '../components/setting-time_application/main.vue';
import SettingApplicationMethod from '../components/setting-application_method/main.vue';
import SettingReceiptPhotography from '../components/setting-receipt_photography/main.vue';
import SettingApplicationRule from '../components/setting-application_rule/main.vue';
import SettingShare from '../components/setting-share/main.vue';
import SettingContact from '../components/setting-contact/main.vue';
import UploadZipLP from '../components/upload-zip/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import ModalListPreview from '@/views/pages/campaign/view/components/ModalListPreview/main.vue';
import { checkPermission } from '@/utils/handlers';

import { mapState } from 'vuex';
import { TABS, TABS_UPLOAD, initFormRegister } from '../constants';
import { validateAllField } from '@/utils/validate';
import { configFormBasicLP } from '../components/setting-basic/constants';
import { configFormTimeApplication } from '../components/setting-time_application/constants';
import { configFormPrizeSettings } from '../components/setting-prize/constants';
import { configFormTargetProduct } from '../components/setting-target_product/constants';
import { configFormApplicationMethods } from '../components/setting-application_method/constants';
import { configFormApplicationRule } from '../components/setting-application_rule/constants';
import { configFormShare } from '../components/setting-share/constants';
import { configFormContact } from '../components/setting-contact/constants';
import { masterMethods, landingPageMethods, managerFormMethods } from '@/state/helpers';
import {
    handleDataBeforeSaveLP,
    validateEndDate,
    validateRangeDate,
    handleDataResponse,
    handleAlertValidateTabs,
    handleRecordLPError,
    handleMapDataFromStateLP,
    syncFormDataToConfigFormBasicLP
} from '../handlers';
import { showMessage } from '@/utils/messages';
import { onHandleShowConfirm } from '@/utils/handlers';
import { configs } from '../constants';
export default {
    name: 'EditLandingPage',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Footer,
        LoadingIcon,
        SettingBasicLP,
        SettingFirstView,
        SettingPrize,
        SettingTargetProduct,
        SettingDesign,
        SettingBlocks,
        SettingTimeApplication,
        SettingApplicationMethod,
        SettingReceiptPhotography,
        SettingApplicationRule,
        SettingShare,
        SettingContact,
        UploadZipLP,
        ModalListPreview
    },

    computed: {
        ...mapState({
            ...mapState('landingPage', ['allInforCampaignLP'])
        })
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('landing_page.edit')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            TABS: TABS(),
            isUploadLP: false,
            formData: initFormRegister(),
            configFormBasicLP: configFormBasicLP(),
            configFormTimeApplication: configFormTimeApplication(),
            configFormPrizeSettings: configFormPrizeSettings(),
            configFormTargetProduct: configFormTargetProduct(),
            configFormApplicationMethods: configFormApplicationMethods(),
            configFormApplicationRule: configFormApplicationRule(),
            configFormShare: configFormShare(),
            configFormContact: configFormContact(),
            configModalListPrv: configs.configModalListPrv,
            dataListCommonUse: {},
            modelTab: 0,
            settingBasicTab: 0,
            isLoading: false,
            listCustomDomains: []
        };
    },
    methods: {
        ...masterMethods,
        ...landingPageMethods,
        ...managerFormMethods,

        handleCancel() {
            this.$router.push({
                path: '/landing-page/list'
            });
        },

        async handleSubmit() {
            syncFormDataToConfigFormBasicLP(this.formData, this.configFormBasicLP);
            let checkValidateTabs = handleAlertValidateTabs(
                {
                    isUploadLP: this.isUploadLP,
                    checkBasicLP: validateAllField(this.configFormBasicLP),
                    checkStartLPWithStartCP: validateEndDate(
                        this.configFormBasicLP['configFieldLPStartDateTime'],
                        this.configFormBasicLP['configFieldCampaignStartDateTime']
                    ),
                    checkStartCPWithEndCP: validateEndDate(
                        this.configFormBasicLP['configFieldCampaignStartDateTime'],
                        this.configFormBasicLP['configFieldCampaignEndDateTime']
                    ),
                    checkEndLPWithEndCP: validateEndDate(
                        this.configFormBasicLP['configFieldCampaignEndDateTime'],
                        this.configFormBasicLP['configFieldLPEndDateTime']
                    ),
                    checkEndDatePublication: validateEndDate(
                        this.configFormBasicLP['configFieldPublicationStartDateTime'],
                        this.configFormBasicLP['configFieldPublicationEndDateTime']
                    ),
                    checkRangePublicationWidthStartLP: validateRangeDate(
                        this.configFormBasicLP['configFieldPublicationStartDateTime'],
                        this.configFormBasicLP['configFieldPublicationEndDateTime'],
                        this.configFormBasicLP['configFieldLPStartDateTime']
                    ),
                    checkTimeApplication: validateAllField(this.configFormTimeApplication),
                    checkTabPrize: validateAllField(this.configFormPrizeSettings), //validateAllField(this.configFormPrizeSettings)
                    checkTabTargetProduct: validateAllField(this.configFormTargetProduct), //validateAllField(this.configFormTargetProduct)
                    checkTabApplicationMethods: validateAllField(this.configFormApplicationMethods), //validateAllField(this.configFormApplicationMethods)
                    checkTabApplicationRule: validateAllField(this.configFormApplicationRule), //validateAllField(this.configFormApplicationRule)
                    checkTabContact: validateAllField(this.configFormContact), //validateAllField(this.configFormContact)
                    checkTabShare: validateAllField(this.configFormShare) //validateAllField(this.configFormShare)
                },
                this.$bvToast,
                this.modelTab
            );
            if (!checkValidateTabs) return;
            let payload = handleDataBeforeSaveLP(this.formData);
            payload.lp_type = this.isUploadLP ? 2 : 1;
            payload.type = this.isUploadLP ? 2 : 1;
            this.isLoading = true;
            try {
                const data = await this.updateLandingPage(payload);
                if (data.code !== 200) {
                    showMessage(data.code, this.$bvToast, this.$t(data.message));
                    return;
                }
                showMessage(data.code, this.$bvToast, '本番LPサイトに反映させるには黄色い本番LPサイト更新のボタンを押してください。');
                showMessage(data.code, this.$bvToast, 'LPが更新されました。');

                if (this.isUploadLP && this.formData?.id) {
                    try {
                        localStorage.setItem(`lp_${this.formData.id}_last_saved_time`, String(Date.now()));
                    } catch (e) {
                        console.error(e);
                    }
                }

                await this.getDetail();
            } catch (error) {
                console.log('error', error);
                this.$bvToast.toast(error?.message || '更新に失敗しました。', {
                    title: 'エラー',
                    variant: 'danger',
                    toaster: 'b-toaster-top-center',
                    solid: true
                });
            } finally {
                this.isLoading = false;
            }
        },

        async getDetail() {
            if (!this.$route?.query?.id) return;
            this.isLoading = true;
            try {
                const response = await this.getDetailLandingPage(this.$route.query.id);
                if (!response?.campaign?.id) {
                    handleRecordLPError(this.$router, this.$route.query.id, this.$bvToast);
                    return;
                }
                this.isUploadLP = response?.lp_type === 2 || response?.type === 2;
                this.TABS = this.isUploadLP ? TABS_UPLOAD() : TABS();
                if (this.configFormBasicLP?.configFieldSaleStaff && this.configFormBasicLP?.configFieldPICinstructions) {
                    this.configFormBasicLP.configFieldSaleStaff.typesValidate = this.isUploadLP ? ['requiredSelect'] : [];
                    this.configFormBasicLP.configFieldPICinstructions.typesValidate = this.isUploadLP ? ['requiredSelect'] : [];
                } else {
                    this.configFormBasicLP = configFormBasicLP(this.isUploadLP);
                }
                const campaignResponse = await this.getDetailCampaignForLandingPage(response.campaign.id);
                handleDataResponse(this.formData, response, campaignResponse);
                this.formData.lp_type = this.isUploadLP ? 2 : 1;
                this.formData.type = this.isUploadLP ? 2 : 1;
                syncFormDataToConfigFormBasicLP(this.formData, this.configFormBasicLP);
                if (!this.isUploadLP) {
                    this.settingOverral({ default_tem: this.formData.style_setting.template_default, font_family: this.formData.style_setting.font });
                }
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        async getListCommonUse() {
            try {
                const dataRes = await this.listMaster('campaign/common-user');
                this.dataListCommonUse['listDataMasterSaleEmploy'] = dataRes['sale']; //2
                this.dataListCommonUse['listUserFilterRole'] = dataRes['admin_and_instructor']; //1,3
                this.dataListCommonUse['listCustomerTeam'] = dataRes['customer_team'];
            } catch (error) {
                console.log('error', error);
            }
        },

        handleGetDetail() {
            this.$router.push({
                path: '/landing-page/view',
                query: {
                    id: this.$route.query.id
                }
            });
        },

        togglePreview() {
            let periodQuery = '';
            if (this.isUploadLP) {
                let period = 'going';
                if (this.modelTab === 1) period = 'start';
                else if (this.modelTab === 2) period = 'going';
                else if (this.modelTab === 3) period = 'end';
                periodQuery = `&period=${period}`;
            }
            window.open(`/landing-page/preview?id=${this.$route.query.id}${periodQuery}`, '_blank');
        },

        getLpPublicUrl() {
            const domainLP = process.env.VUE_APP_DOMAIN_LP;
            let domainStr = this.formData?.custom_domain?.domain || null;
            if (this.formData?.published_domain) {
                domainStr = this.formData.published_domain;
            } else {
                if (!domainStr && this.formData?.custom_domain_id && this.listCustomDomains.length) {
                    const found = this.listCustomDomains.find((d) => d.id === this.formData.custom_domain_id);
                    if (found) domainStr = found.domain;
                }
            }
            const domain = domainStr || domainLP;
            return `https://${domain}/landing-page/${this.formData.url_public}`;
        },

        async onHandleTranformPage() {
            if (this.formData.is_first_publish === 0) {
                try {
                    let payload = { id: this.formData.id };
                    await this.syncLandingPagePublish(payload);
                    window.open(this.getLpPublicUrl(), '_blank');
                } catch (error) {
                    console.log('error', error);
                }
            } else {
                window.open(this.getLpPublicUrl(), '_blank');
            }
        },

        async onHandleRefreshCPOnLP() {
            const confirmRefresh = await onHandleShowConfirm({ title: '', text: 'キャンペンの最新情報をLP管理に取り込みます。よろしいですか。' });
            if (!confirmRefresh) return;
            handleMapDataFromStateLP(this.formData, this.allInforCampaignLP, 'refreshCP');
            this.incrementRefresh();
        },

        async onHandleSyncLandingPage() {
            const confirmSync = await onHandleShowConfirm({ title: '', text: '最新の更新内容を本番LPサイトに反映します。よろしいですか。' });
            if (!confirmSync) return;
            try {
                let payload = {
                    id: this.formData.id
                };
                await this.syncLandingPagePublish(payload);
                const response = await this.getDetailLandingPage(this.$route.query.id);
                this.formData.last_publish_updated = response.last_publish_updated;
                this.formData.published_domain = response.published_domain ?? null;
            } catch (error) {
                console.log('error', error);
                showMessage(error.code, this.$bvToast, error.message);
            }
        },

        async onGetListCustomDomain() {
            try {
                const response = await this.getListCustomDomain('limit=1000');
                if (response?.data) {
                    this.listCustomDomains = response.data;
                }
            } catch (error) {
                console.log('error', error);
            }
        }
    },
    async mounted() {
        this.getListCommonUse();
        this.onGetListCustomDomain();
        await this.getDetail();
    }
};
</script>

<style lang="scss"></style>
